import { createAction, props } from '@ngrx/store';

import { TagsState } from '../states';

enum TagsActions {
    TAGS_GET_APPS_BY_KEY_VALUES = '[TAGS] Get Apps By Key Values',
    TAGS_SET_APPS_BY_KEY_VALUES = '[TAGS] Set Apps By Key Values',
    TAGS_GET_ASSET = '[TAGS] Get Asset Tags',
    TAGS_SET_ASSET = '[TAGS] Set Asset Tags',
}

export const GetTagAppsByKeyValues = createAction(
    TagsActions.TAGS_GET_APPS_BY_KEY_VALUES,
    props<{
        tagKey: string;
        tagValue: string;
        noAlerts?: boolean;
    }>()
);

export const SetTagAppsByKeyValues = createAction(
    TagsActions.TAGS_SET_APPS_BY_KEY_VALUES,
    props<{
        apps: TagsState['organizationsMap']['key']['tagKeyValuesVsAppDetails']['key'];
        tagKey?: string;
        tagValue?: string;
        status?: string;
        organizationId?: string;
    }>()
);

export const GetAssetTags = createAction(
    TagsActions.TAGS_GET_ASSET,
    props<{
        serviceId: string;
    }>()
);

export const SetAssetTags = createAction(
    TagsActions.TAGS_SET_ASSET,
    props<{
        serviceId: string;
        tagKeyValues: { [property: string]: string };
    }>()
);
